<template>
    <!-- ------------------------------------------------------------------------------------------------------------------------------------ -->
    <!-- 도움말 -->
    <!-- ------------------------------------------------------------------------------------------------------------------------------------ -->

    <div v-show="isShow" style="max-width: 800px; background-color: white; border: 3px solid #808080; position: absolute; z-index: 10000;"
      v-draggable="draggableOpts">
      <i-bar ref="drag_handle" title="귀속 수임사건의 건수 및 수임액 신고서 작성방법" class="window-header pop_tit">
      </i-bar>
        <p class="right m5">
          <button type="button" class="btn gray01" @click="$htmlToPaper('printMe')">인쇄</button>
          <i-bar-btn @click="hide()">닫기</i-bar-btn>
        </p>
      <div class="cont" style="padding: 10px; margin-top:50px;" id="printMe">
        <h2 style="text-align: center">귀속 수임사건의 건수 및 수임액 신고서 작성방법</h2>
        <ol style="margin-top: 10px;">
          <li>수임액
              <p>신고할 귀속 수임연도의 기간 중 수임한 사건의 총 수임액(부가세 포함)을 기재하시기바랍니다</p>
          </li>
          <li>수임액 제외
            <p>가. 고문료, 자문료 등 사무보수</p>
            <p>나. 국선변호인사건, 법원의 소송구조사건</p>
            <p>(국선변호사건 등은 소속 법률사무소의 업무와 관련 없이 독립된 개인변호사의 자격으로 수행하는 사업소득 또는  기타소득에 해당하고, 해당 법률사무소에서 이와 같이 이루어진 소속변호사의 국선변호사건 등을 파악하여 합산 신고하기가 쉽지 않아 국선변호사건과 소송구조사건은 수임액 신고에서 제외함)</p>
          </li>
          <li>성공보수
            <p>전년도에 수임한 사건의 성공보수금을 당해연도에 수령한 경우에는 수임사건 건수에 포함하지 마시고, 수임액에 성공보수금(부가세 포함)을 합산하여 기재하시기 바랍니다.</p>
          </li>
          <li>건수
            <p>가. 수임일 기준으로 산정하시기 바랍니다.</p>
            <p> &nbsp; &nbsp; [ 경유홈페이지 > 수임사건 내역조회 > 수임사건 건수 조회 > 조회일자 : 수임일]</p>
            <p>나. 공동명의로 수임한 경우라도 각 1건으로 산정합니다.</p>
          </li>
          <li>본안사건뿐 아니라 신청사건을 동시에 수임한 경우
            <p>건수는 본안 1건, 신청 1건으로 기재하고, 수임액은 분불할 수 없으므로 본안사건에 포함하여 기재합니다.</p>
          </li>
          <li>귀속 수임기간 중 개인회원(법무법인)에서 법무법인(개인회원) 등으로 이직하였을 경우
            <p>신고할 귀속 수임연도의 기간 중 수임한 사건 모두를 신고해야 합니다.
              법무법인, 법무법인(유한), 공동법률사무소(대한변협에 신고한)는 법인 등 계정 아이디로 신고할 경우 해당 법무법인 등에 소속된 변호사 모두 신고한 것으로 처리됩니다(소속된 담당변호사가 개별로 신고할 필요 없음).
              <!-- 통상 법무법인에서 마스터 아이디로 귀속 수임사건을 신고할 경우 귀속 수임연도 기간 중에 소속되었던 변호사 모두를 포함하여 신고 처리됩니다.만약 개인사무실 또는 이전 법무법인 등에서 수임한 사건이 있을 경우 수임액 신고를 별도로 신고하셔야 합니다. -->
              </p>
          </li>
          <li>법무법인의 주사무소가 우리 회 소속인 경우
            <p>법무법인의 주사무소뿐 아니라 분사무소의 수임사건 건수 및 수임액도 합산 신고하여야 합니다. (분사무소만 별도로 신고를 원할경우 추가신고하기로 개별로 신고가능)
              <!-- 신고하고, 신고인의 인적사항란에는 우리 회 소속 회원명을 전부 기재합니다. -->
              </p>
          </li>
          <li>법무법인의 주사무소는 타회 소속이고, 분사무소의 소속된 변호사는 우리 회 회원인 경우
            <p>공동신고인에는 분사무소에 소속된 우리 회 소속 회원을 전부 추가하고, 수임사건의 건수 및 수임액란에는 분사무소에서 처리한 수임사건의 건수 및 수임액을 기재합니다.</p>
          </li>
          <li>회사, 국영기업체 및 대한법률구조공단 등에 소속된 고용 또는 사내변호사로서 별도의 사업자등록증이 없는 경우
            <p>수임사건의 건수와 수임액이 있는 경우에는 해당 건수 및 수임액을 기재하고, 건수 및 수입액 등이 없는 경우에는 ‘무수임 신고’로 제출해 주시기 바랍니다.</p>
          </li>
        </ol>
      </div>
    </div>
</template>

<script>
import { Draggable } from 'draggable-vue-directive' // https://github.com/IsraelZablianov/draggable-vue-directive
export default {
  directives: {
    Draggable,
  },
  data() {
    return {
      isShow: false,
      draggableOpts: {
        handle: undefined, // mounted() 할때 지정할 예정
        resetInitialPos: true,
        initialPosition: {left: 0, top: 0},
      },
    }
  },
  mounted() {
    this.draggableOpts.handle = this.$refs.drag_handle
    // this.hide()
  },
  methods: {
    show() { this.isShow = true },
    hide() { this.isShow = false },
  },
}
</script>